import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-virtual-pagare',
  templateUrl: './virtual-pagare.component.html',
  styleUrls: ['./virtual-pagare.component.css']
})
export class VirtualPagareComponent implements OnInit {

  public from : FormGroup;
  public testBase64 : string = localStorage.getItem("pagareBase64");
  constructor() { }

  ngOnInit(): void {
    var obj = document.createElement('object'); 
    obj.style.width = '100%';
    obj.style.height = '842pt';
    obj.type = 'application/pdf';
    obj.data = 'data:application/pdf;base64,' + [this.testBase64];
    document.body.appendChild(obj);
  }
}
